// Browsers (Chrome in particular) block or silently fail to render a
// top-level navigation to a `data:` URI opened via `target="_blank"` —
// symptom: a grey screen, then a blank tab, no error. This affects any
// provider whose label comes back as inline base64 (currently Parcel2Go —
// see shared/providers/parcel2go-provider.ts getLabel()). A `blob:` URL
// (created from the same bytes) is exempt from this restriction and opens
// reliably everywhere. Converts once per call; the browser releases the
// blob URL when the tab/document is unloaded, so no explicit revoke is
// needed for a one-off "open in a new tab" click.
export function toOpenableUrl(url: string): string {
  if (!url.startsWith("data:")) return url;
  const commaIndex = url.indexOf(",");
  if (commaIndex === -1) return url;
  const header = url.slice(5, commaIndex); // strip "data:"
  const data = url.slice(commaIndex + 1);
  const isBase64 = header.endsWith(";base64");
  const mime = (isBase64 ? header.slice(0, -";base64".length) : header) || "application/octet-stream";

  try {
    const binary = isBase64 ? atob(data) : decodeURIComponent(data);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
    return URL.createObjectURL(new Blob([bytes], { type: mime }));
  } catch {
    return url; // fall back to the original data: URI rather than breaking the link entirely
  }
}
